﻿import { atom } from "jotai";
import { QuestionnaireValues } from "@am-tax/wotc-common";

export const pageTitleAtom = atom<string | null | undefined>("WOTC");
export const questionnaireValuesAtom = atom<QuestionnaireValues>({});
